import useSWR from "swr";

import { simpleFetcher } from "../fetcher";
import {
  type VerifySpAccessResponse,
  type SpDrive,
  type SpSite,
} from "~/api/types";

export function useSpSites({ search }: { search?: string }) {
  let sitesUrl = "/api/v2/sp/sites";

  const params = new URLSearchParams();

  if (search) {
    params.set("search", search);
  }

  const query = params.toString();

  if (query) {
    sitesUrl += `?${query}`;
  }

  return useSWR<SpSite[], Error>(sitesUrl, simpleFetcher, {
    shouldRetryOnError: false,
    revalidateIfStale: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
  });
}

export function useSpDrives(siteId: string | null) {
  const drivesUrl = siteId ? `/api/v2/sp/sites/${siteId}/drives` : null;
  return useSWR<SpDrive[], Error>(drivesUrl, simpleFetcher, {
    shouldRetryOnError: false,
    revalidateIfStale: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
  });
}

const verifyAccessUrl = "/api/v2/sp/verify";

export function useSpVerifyAccess() {
  return useSWR<VerifySpAccessResponse, Error>(verifyAccessUrl, simpleFetcher, {
    shouldRetryOnError: false,
    revalidateIfStale: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
  });
}
